import { useForm } from "react-hook-form"
import IndividualInfo from "./IndividualInfo"
import CreatePassword from "./CreatePassword"
import AddressInfo from "./AddressInfo"
import MedicalInfo from "./MedicalInfo"
import usePatient from "@hooks/usePatient"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
const AddPatientForm = () => {
  const navigate = useNavigate()
  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      password: "",
      repeatPassword: "",
      country: "",
      province: "",
      pincode: "",
      address: "",
      eye: "",
      email: "",
      contact: "",
    },
  })
  const [clickedButton, setShowClickedButton] = useState(null)
  const { handleAddNewPatient } = usePatient()
  const { ownDetails } = useSelector((state) => state.profile)
  const { myReferenceNumber } = ownDetails || {}
  const { email } = ownDetails?.details || {}
  const formSubmit = (data) => {
    let addNewPatientSuccess
    if (clickedButton === "save") {
      addNewPatientSuccess = () => {
        navigate("/manage-patient-vision")
      }
    } else {
      addNewPatientSuccess = () => {
        navigate(`/subscribe?email=${data.email}&name=${data.firstName}`)
      }
    }
    handleAddNewPatient(
      {
        ...data,
        requestType: "Doctor",
        referenceNumber: myReferenceNumber,
        createdBy: email,
      },
      addNewPatientSuccess
    )
  }
  return (
    <form
      onSubmit={handleSubmit(formSubmit)}
      className="flex gap-4 md:gap-10 flex-wrap max-w-[22rem] md:max-w-none w-full"
    >
      <IndividualInfo watch={watch} control={control} errors={errors} />
      <CreatePassword watch={watch} control={control} errors={errors} />

      <AddressInfo
        watch={watch}
        control={control}
        errors={errors}
        setValue={setValue}
      />

      <MedicalInfo
        watch={watch}
        control={control}
        errors={errors}
        setShowClickedButton={setShowClickedButton}
      />
    </form>
  )
}

export default AddPatientForm
